<template>
    <Card dis-hover :bordered="false">
        <Form :model="searchForm"
              :label-width="100"
              :style="{maxHeight: collapse[collapseType].maxHeight, overflow: collapse[collapseType].overflow}"
              ref="searchForm">
            <Row>
                <Col span="19">
                    <Row :gutter="0">
                        <Col span="8">
                            <FormItem :label="$t('createMaterialLabel.deliveryNO')" prop="deliveryNumber">
                                <Input v-model="searchForm.deliveryNumber" placeholder="" clearable size="small"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem :label="$t('createMaterialLabel.notifyNo')" prop="notifyNumber">
                                <Input v-model="searchForm.notifyNumber" placeholder="" clearable size="small"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem :label="$t('createMaterialLabel.item')" prop="itemCodeStart">
                                <Row :gutter="0">
                                    <Col span="11">
                                        <FormItem prop="itemCodeStart">
                                            <Input type="text" placeholder=""
                                                   v-model="searchForm.itemCodeStart" size="small"></Input>
                                        </FormItem>
                                    </Col>
                                    <Col span="2" style="text-align: center">-</Col>
                                    <Col span="11">
                                        <FormItem prop="itemCodeEnd">
                                            <Input type="text" placeholder=""
                                                   v-model="searchForm.itemCodeEnd" size="small"></Input>
                                        </FormItem>
                                    </Col>
                                </Row>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem :label="$t('createMaterialLabel.subinventory')" prop="subInventory">
                                <Input v-model="searchForm.subInventory" placeholder="" clearable size="small"></Input>
                            </FormItem>
                        </Col>
                        <Col span="8">
                            <FormItem :label="$t('createMaterialLabel.podLine')" prop="produceLine">
                                <Input v-model="searchForm.produceLine" placeholder="" clearable size="small"></Input>
                            </FormItem>
                        </Col>
                        <Col span="24" class="mtb10">
                            <span class="fs12">{{$t('createMaterialLabel.t6')}}：</span>
                            <Checkbox v-model="deliveryQtyFlag" @on-change="qtyOnChange($event, 'deliveryQtyFlag')">{{$t('createMaterialLabel.t7')}}</Checkbox>
                            <Checkbox v-model="lastMinFlag" @on-change="qtyOnChange($event, 'lastMinFlag')">{{$t('createMaterialLabel.t8')}}</Checkbox>
                        </Col>
                    </Row>
                </Col>
                <Col span="5" style="float: right; width: 220px;">
                  <Row type="flex" justify="end" align="middle">
                    <Col span="24" style="padding-top: 5px;text-align: right;">
                      <Button type="primary" @click="onSearch" size="small" :loading="loading">{{$t('common.queryBtn')}}</Button>
                      <Button type="ghost" @click="clearData" class="mg-ll-5" size="small">{{$t('common.clearBtn')}}</Button>
                      <Button type="ghost" @click="toTheUrl('DeliveryOrderQuery')" class="mg-ll-5" size="small">{{$t('common.back')}}
                      </Button>
                      <!-- <a class="btn-collapse" href="javascript: void(0)" @click="handleCollapse" style="margin: 0 2px 0 10px;">
                          {{collapse[collapseType].text}}
                      </a> -->
                      <a class="btn-collapse" href="javascript: void(0)" @click="handleCollapse" style="margin-left:5px;"><Icon :type="collapse[collapseType].icon"></Icon></a>
                    </Col>
                  </Row>
                </Col>
            </Row>
        </Form>

        <div class="set-flex" style="justify-content: space-between;">
            <div>
                <Button type="primary" class="each-btn" @click="beforeConfirm" :disabled="selection.length === 0" :loading="loading">
                    {{$t('createMaterialLabel.confirm')}}
                </Button>
                <Button type="primary" class="each-btn" @click="beforePrint" :disabled="selection.length === 0" :loading="printLoading || loading">
                    {{$t('createMaterialLabel.print')}}
                </Button>
                <set-table class="each-btn" :columns="tableColumns" @setTableUpdate="setTableUpdate"></set-table>
            </div>
        </div>
        <div class="createMaterialLabelTable">
            <Table ref="table" :columns="tableColumns" :data="tableData" :loading="loading" :height="550" stripe border
               highlight-row disabled-hover @on-selection-change="onSelectionChange" size="small"></Table>
        </div>

        <Modal v-model='tempModal'
               :title="this.$t('common.warn')"
               width="650">
            <p style="font-weight: 800;font-size: 14px;">{{$t('createMaterialLabel.tb1')}}</p><!-- 存在物料 -->
            <p v-for="(item, index) in tempContent" :key="index">{{item}}</p>
            <p style="font-weight: 800;font-size: 14px;">{{$t('createMaterialLabel.tb5')}}</p>
            <div slot="footer" style="text-align:right;">
                <Button @click="tempModal = false">{{$t('createMaterialLabel.no')}}</Button>
                <Button type="primary" @click="createLabel" :loading="loading" style="margin-left:10px;">{{$t('createMaterialLabel.yes')}}</Button>
            </div>
        </Modal>
    </Card>
</template>
<script>
import axios from 'axios';
import {formatDateTime} from '@/utils/datetime-format.js';
// import { poolPrintPreDo } from '@/utils/index';

export default {
    name: 'createMaterialLabel',
    data() {
        return {
            tagPackingQuantityType: '',
            lastMinFlag: false,
            deliveryQtyFlag: false,
            maxPrintNumber: 300, // 最大打印数量
            searchForm: {
                deliveryNumber: '', // 送货单号
                notifyNumber: '', // 通知号
                itemCodeStart: '', // 物料编码开始
                itemCodeEnd: '', // 物料编码结束
                subInventory: '', // 子库
                produceLine: '', // 产线
            },
            loading: false,
            tableData: [],
            tableColumns: [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center'
                },
                { // 查看标签
                    title: this.$t('createMaterialLabel.label'),
                    key: 'intTagFlag',
                    align: 'center',
                    width: 60,
                    render: (h, params) => {
                        let intTagFlag = params.row.intTagFlag;
                        return h('Icon', {
                            props: {
                                type: 'ios-circle-filled',
                                size: 27,
                                color: '#DCDCDC'
                            },
                            style: {
                                cursor: intTagFlag ? 'pointer' : 'not-allowed',
                                color: intTagFlag ? '#009DD9' : '#666666'
                            },
                            nativeOn: {
                                click: () => {
                                    if (intTagFlag) {
                                        this.beforePrintSingleLabel(params.row);
                                    }
                                }
                            }
                        });
                    }
                },
                { // 送货单号
                    title: this.$t('createMaterialLabel.deliveryNO'),
                    key: 'deliveryNumber',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                { // 送货通知号
                    title: this.$t('createMaterialLabel.notifyNo'),
                    key: 'notifyNumber',
                    align: 'center',
                    width: 130
                },
                { // 保税类型
                    title: this.$t('createMaterialLabel.bondedType'),
                    key: 'bonded', // 保税/非保税
                    align: 'center',
                    width: 130
                },
                { // 条码号
                    title: this.$t('createMaterialLabel.barCodeNo'),
                    key: 'deliveryBarcode',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                { // 单据状态
                    title: this.$t('createMaterialLabel.status'),
                    key: 'deliveryStatus',
                    width: 70,
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        let obj = this.deliverystatusList.find((item) => item.value === params.row.deliveryStatus);
                        if (obj && obj.label) {
                            return h('span', obj.label);
                        } else {
                            return h('span', '');
                        }
                    }
                },
                { // 物料编码
                    title: this.$t('createMaterialLabel.item'),
                    key: 'itemCode',
                    align: 'center',
                    width: 130,
                    sortable: true
                },
                { // 物料描述
                    title: this.$t('createMaterialLabel.itemDesc'),
                    key: 'itemName',
                    align: 'center',
                    width: 250,
                    render: (h, params) => {
                        return h('Tooltip', {
                            props: {
                                content: params.row.itemName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                        }, params.row.itemName);
                    }
                },
                { // 送货数量
                    title: this.$t('createMaterialLabel.deliveryQty'),
                    key: 'deliveryQuantity',
                    align: 'center',
                    width: 90
                },
                { // 包装数量
                    title: this.$t('createMaterialLabel.qty'),
                    renderHeader: (h, params) => {
                        return h('span', {}, [
                            h('span', {
                                style: {
                                    color: '#ff0000'
                                }
                            }, ['* ']),
                            h('span', {}, [this.$t('createMaterialLabel.qty')])
                        ]);
                    },
                    key: 'tagPackingQuantity',
                    align: 'center',
                    width: 90,
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                value: params.row.tagPackingQuantity
                            },
                            on: {
                                'on-blur': (event) => {
                                    if (event.target.value) {
                                        if (!this.validatePositive(event.target.value)) {
                                            this.$Modal.error({
                                                title: this.$t('common.warn'),
                                                content: this.$t('createMaterialLabel.t2') // '"包装数量"请输入正数'
                                            });
                                            params.row.tagPrintAmount = null;
                                        } else {
                                            params.row.tagPackingQuantity = Number(event.target.value);
                                            if (event.target.value > params.row.deliveryQuantity) {
                                                params.row.tagPrintAmount = 1;
                                            } else {
                                                params.row.tagPrintAmount = Math.ceil(Number(params.row.deliveryQuantity) / Number(event.target.value));
                                            }
                                        }
                                    } else {
                                        params.row.tagPrintAmount = null;
                                    }
                                    this.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                { // 标签数量
                    title: this.$t('createMaterialLabel.labelCount'),
                    key: 'tagPrintAmount',
                    align: 'center',
                    width: 80
                },
                { // 生产日期/排产日期
                    title: this.$t('createMaterialLabel.moStartTime'),
                    renderHeader: (h, params) => {
                        return h('span', {}, [
                            h('span', {
                                style: {
                                    color: '#ff0000'
                                }
                            }, ['* ']),
                            h('span', {}, [this.$t('createMaterialLabel.moStartTime')])
                        ]);
                    },
                    key: 'produceDate',
                    align: 'center',
                    width: 170,
                    style: 'width:100%',
                    render: (h, params) => {
                        return h('DatePicker', {
                            props: {
                                type: 'date',
                                clearable: true,
                                format: 'yyyy-MM-dd', // yyyy-MM-dd HH:mm:ss
                                value: params.row.produceDate
                            },
                            style: {
                                width: '100%'
                            },
                            on: {
                                'on-change': (data) => {
                                    params.row.produceDate = data;
                                    this.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                { // 物料批次/生产批次
                    title: this.$t('createMaterialLabel.lot'),
                    renderHeader: (h, params) => {
                        return h('span', {}, [
                            h('span', {
                                style: {
                                    color: '#ff0000'
                                }
                            }, ['* ']),
                            h('span', {}, [this.$t('createMaterialLabel.lot')])
                        ]);
                    },
                    key: 'itemSupprodbath',
                    align: 'center',
                    width: 100,
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                value: params.row.itemSupprodbath
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.itemSupprodbath = event.target.value;
                                    this.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                { // 子库
                    title: this.$t('createMaterialLabel.subinventory'),
                    key: 'subInventory',
                    align: 'center',
                    minWidth: 100
                },
                // {
                //     title: '事业部子库',
                //     key: 'attribute10',
                //     align: 'center',
                //     minWidth: 65
                // },
                { // 作业号
                    title: this.$t('createMaterialLabel.mo'),
                    key: 'wipEntityName',
                    align: 'center',
                    width: 150,
                    sortable: true,
                    render: (h, params) => {
                        return h('Tooltip', {
                            props: {
                                content: params.row.wipEntityName,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                        }, params.row.wipEntityName);
                    }
                },
                { // 排产量
                    title: this.$t('createMaterialLabel.moQty'),
                    key: 'produceQuantity',
                    align: 'center',
                    minWidth: 90
                },
                { // 备注
                    title: this.$t('createMaterialLabel.remark'),
                    key: 'remarks',
                    align: 'center',
                    width: 300,
                    render: (h, params) => {
                        return h('Input', {
                            props: {
                                type: 'text',
                                clearable: true,
                                value: params.row.remarks
                            },
                            on: {
                                'on-blur': (event) => {
                                    params.row.remarks = event.target.value;
                                    this.tableData[params.index] = params.row;
                                }
                            }
                        });
                    }
                },
                { // 生产线
                    title: this.$t('createMaterialLabel.podLine'),
                    key: 'produceLine',
                    minWidth: 160
                }
            ],
            orderParams: {}, // 从送货单查询获取的参数
            selection: [],
            selectionArr: [], // 存存点击确定时勾选的行
            tempModal: false,
            tempContent: [],
            printLoading: false,
            // deliverystatusList: [], // 快码数据单据状态
            isJdTAGTemplate: false,
            collapse: {
                up: {
                    text: this.$t('common.retract'), // 收起
                    icon: 'chevron-up',
                    maxHeight: '240px',
                    overflow: 'visible'
                },
                down: {
                    text: this.$t('common.expand'), // 展开
                    icon: 'chevron-down',
                    maxHeight: '40px',
                    overflow: 'hidden'
                }
            },
            collapseType: 'up'
        };
    },
    methods: {
        /** 收起展开**/
        handleCollapse() {
            if (this.collapseType === 'up') {
                this.collapseType = 'down';
            } else {
                this.collapseType = 'up';
            }
        },
        /** 清除按钮 */
        clearData() {
            this.$refs['searchForm'].resetFields();
        },
        /** 路由跳转 */
        toTheUrl(url) {
            this.$router.push(url);
        },
        /** 获取标签送货单的信息 */
        onSearch() {
            let params = {
                language: this.$i18n.locale, // 必填
                vendorCode: this.supplierInfo.vendorCode,
                deliveryBarcodes: this.orderParams.barcodes,
                orgCode: this.orderParams.orgCode,
                orgId: this.orderParams.orgId,
                orgName: this.orderParams.orgName,
                ...this.searchForm
            };
            this.tableData = [];
            this.loading = true;
            this.printLoading = true;
            axios.post('/gscint/itemTagInt/intOrderList', params)
            .then(res => {
                    this.loading = false;
                    this.printLoading = false;
                    let rep = res.data;
                    if (rep.data.success === true) {
                        let tempList = rep.data.data.rows;
                        this.selection = [];
                        let deliveryNumbers = [];
                        this.selectionArr.map((item) => {
                            if (!deliveryNumbers.includes(item.deliveryNumber)) {
                                deliveryNumbers.push(item.deliveryNumber);
                            }
                        });
                        console.log('deliveryNumbers::', deliveryNumbers);
                        tempList.map((item, key) => {
                            if (deliveryNumbers.includes(item.deliveryNumber)) {
                                tempList[key]['_checked'] = true;
                                this.selection.push(tempList[key]);
                            }
                        });
                        console.log('seach_tempList,this.selection', tempList, this.selection);
                        this.tableData = tempList;
                        let currentDate = formatDateTime(new Date(), 'yyyy-MM-dd');
                        let currentDate2 = formatDateTime(new Date(), 'yyMMdd');
                        for (let i = 0; i < this.tableData.length; i++) {
                            // 生产日期
                            this.tableData[i]['produceDate'] = (this.tableData[i]['produceDate'] ? this.tableData[i]['produceDate'] : currentDate);
                            // 物料批次
                            this.tableData[i]['itemSupprodbath'] = currentDate2;
                            // 排产量
                            this.tableData[i]['produceQuantity'] = this.tableData[i]['produceQuantity'] ? this.tableData[i]['produceQuantity'] : 0;
                            // 标签数量
                            this.tableData[i]['tagPrintAmount'] = this.tableData[i]['tagPrintAmount'] ? this.tableData[i]['tagPrintAmount'] : (this.tableData[i]['tagPackingQuantity'] ? Math.ceil(Number(this.tableData[i]['deliveryQuantity']) / Number(this.tableData[i]['tagPackingQuantity'])) : null);
                            // 包装数量
                            this.tableData[i]['tagPackingQuantity'] = this.tableData[i]['tagPackingQuantity'] ? this.tableData[i]['tagPackingQuantity'] : null;
                            /*  默认包装数量赋值 */
                            if (this.tagPackingQuantityType) {
                                this.tableData[i].tagPackingQuantity = this.tableData[i][this.tagPackingQuantityType];
                            }
                        }
                        console.log('this.tableData::', this.tableData);
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: rep.data.message
                        });
                    }
                }
            ).catch(() => {
                this.loading = false;
                this.printLoading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 勾选框变化 */
        onSelectionChange(selection) {
            this.selection = selection;
        },
        /** 数据验证:非空 */
        validateNotEmpty() {
            let notEmptyArr = [];
            this.vaiNonEmpty = function (vLabel, vData) {
                if (vData === null || vData === undefined || vData === '') {
                    if (notEmptyArr.indexOf(vLabel) === -1) {
                        notEmptyArr.push(vLabel);
                    }
                }
            };
            for (let i = 0; i < this.selection.length; i++) {
                let index = this.tableData.findIndex(item => item.deliveryLineId === this.selection[i].deliveryLineId);
                for (let j in this.tableData[index]) {
                    if (j === 'tagPackingQuantity') {
                        this.vaiNonEmpty(this.$t('createMaterialLabel.qty'), this.tableData[index][j]);
                    }
                    if (j === 'produceDate') {
                        this.vaiNonEmpty(this.$t('createMaterialLabel.moStartTime'), this.tableData[index][j]);
                    }
                    if (j === 'itemSupprodbath') {
                        this.vaiNonEmpty(this.$t('createMaterialLabel.lot'), this.tableData[index][j]);
                    }
                }
            }
            if (notEmptyArr.length > 0) {
                return notEmptyArr.join(',') + this.$t('createMaterialLabel.notBeEmpty');
            } else {
                return '';
            }
        },
        beforeConfirm() {
            let notEmptyData = this.validateNotEmpty();
            if (notEmptyData) {
                this.$Message.error({
                    content: notEmptyData,
                    duration: 3
                });
                return false;
            } else {
                this.handleConfirm();
            }
        },
        handleConfirm() {
            let selecteds = this.$refs.table.getSelection();
            if (selecteds.find((item) => item.deliveryStatus !== 'OPEN')) {
                this.$Modal.error({
                    content: this.$t('createMaterialLabel.t4') // '勾选送货单存在关闭或取消状态，不可创建物料标签，请检查后再勾选。'
                });
                return false;
            }
            let ids = [],newArr = [];
            let allOk = true,flag = true;
            selecteds.forEach(val => {
                if (val.deliveryQuantity / val.tagPackingQuantity > this.maxPrintNumber) {
                    allOk = false;
                    ids.push(val.deliveryNumber);
                }
                console.log('ids::', ids);
                if (val.intTagFlag) {
                    newArr.push(`(${this.$t('createMaterialLabel.tb2')}：'${val.deliveryNumber}'、${this.$t('createMaterialLabel.tb3')}：'${val.itemCode}'、${this.$t('createMaterialLabel.tb4')}：'${val.wipEntityName}'）`);
                    flag = false;
                }
            });
            if (!allOk) {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('createMaterialLabel.ta1') + `${ids.join()}${this.$t('createMaterialLabel.ta2')}${this.maxPrintNumber}！`
                });
                return false;
            }
            if (!flag) {
                this.tempContent = newArr;
                this.tempModal = true;
            } else {
                this.createLabel();
            }
        },
        /** 生成标签 */
        createLabel() {
            let selecteds = this.$refs.table.getSelection();
            console.log('selecteds::', selecteds);
            let params = {
                language: this.$i18n.locale, // 必填
                vendorCode: this.supplierInfo.vendorCode,
                vendorName: this.supplierInfo.vendorName,
                vendorAccount: this.supplierInfo.userName,
                tagIntList: [...selecteds]
            };
            this.selectionArr = [...selecteds];
            this.loading = true;
            axios.post('/gscint/itemTagInt/add', params).then(res => {
                    this.loading = false;
                    let rep = res.data;
                    if (rep.data.success) {
                        this.tempModal = false;
                        this.$Modal.success({
                            title: this.$t('common.warn'),
                            content: this.$t('createMaterialLabel.t3') // '生成标签成功'
                        });
                        this.onSearch();
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: rep.data.message
                        });
                    }
                }
            ).catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 获取打印的数据 */
        getPrintList(barcodes) {
            this.printLoading = true;
            let url = `/gscint/itemTagInt/${this.isJdTAGTemplate ? 'queryThaiEmTagPrintList' : 'getPrintList'}`;
            return new Promise(resolve => {
                axios.post(url, barcodes).then(res => {
                        this.printLoading = false;
                        let rep = res.data;
                        if (rep.data.success === true) {
                            if (this.isJdTAGTemplate) {
                                if (rep.data.datas.length > 0) {
                                    resolve(rep.data.datas);
                                }
                            } else {
                                if (rep.data.data.rows.length > 0) {
                                    resolve(rep.data.data.rows);
                                }
                            }
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: rep.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.printLoading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            });
        },
        /** 打印前的验证 */
        beforePrint() {
            //  先过滤未确定的行
            let selecteds = this.$refs.table.getSelection();
            let filterDatas = selecteds.filter(item => {
                return item.intTagFlag === true;
            });
            console.log('filterDatas::', filterDatas);
            if (filterDatas.length === 0) {
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('createMaterialLabel.t5') // '当前勾选的行皆未确定'
                });
            } else {
                //  过滤出barcodeNumber
                let barcodeNumber = [];
                for (let i = 0; i < filterDatas.length; i++) {
                    barcodeNumber.push({
                        deliveryBarcode: filterDatas[i].deliveryBarcode,
                        itemCode: filterDatas[i].itemCode,
                        wipEntityId: filterDatas[i].wipEntityId,
                        orgCode: filterDatas[i].orgCode
                    });
                }
                this.getPrintList(barcodeNumber).then(rep => {
                    this.printLabel(rep);
                });
            }
        },
       /** 打印 */
        printLabel(printData) {
            this.printLoading = true;
            let cpt = '';
            let tempCode = '';
            let { orgCode } = this.orderParams;
            // 判断是否GAT泰国机电标签打印
            let isJdTAGEmail = (this.INT_CUX_ITEM_TAG_TEMPLATE.find(item => item.code === orgCode) || {}).email;
            this.isJdTAGTemplate = isJdTAGEmail === '1';
            if (this.isJdTAGTemplate) {
                /* 是否启用云打印 */
                tempCode = 'THAI_EM_TAG';
                if (!this.isCloundPrint({reportlets: printData}, orgCode, this.supplierInfo.vendorCode, [], tempCode)) {
                    cpt = `srm/THAI_EM_TAG${this.isPro() ? '' : '_UAT'}.cpt`;
                    /** 帆软打印 */
                    setTimeout(() => {
                        window.printWindow = window.open();
                        this.$mprint.doURLPDFprint({
                            cpt,
                            data: printData,
                            printType: 'diePay'
                        });
                    }, 100);
                }
            } else {
                tempCode = 'INT_TAG_TEST';
                this.cloudPrint(tempCode, {reportlets: printData});
            }
            this.printLoading = false;
        },
        /** 打印单条标签 */
        beforePrintSingleLabel(lineData) {
            let barcodes = [];
            barcodes.push({
                deliveryBarcode: lineData.deliveryBarcode,
                itemCode: lineData.itemCode,
                wipEntityId: lineData.wipEntityId,
                orgCode: lineData.orgCode
            });
            this.getPrintList(barcodes).then(rep => {
                this.printLabel(rep);
            });
        },
        /** 验证正数 */
        validatePositive(needTest) {
            const rel = /^[0-9]+\.?[0-9]{0,9}$/;
            return rel.test(needTest);
        },
        // 获取最大打印数量
        getMaxPrintNum () {
            axios.get('/gscint/sys/sysParam/queryDictionaryData?dictCode=CUX_UID_COUNT_SET&isValid=Y')
            .then((res) => {
                if (res.data.data.length > 0) {
                    this.maxPrintNumber = res.data.data[0].value;
                }
            });
        },
        setTableUpdate(columns) {
            this.tableColumns = columns;
        },
        qtyOnChange(val, type) {
            this[type] = val;
            if (val) {
                if (type === 'deliveryQtyFlag') {
                    this.lastMinFlag = false;
                } else {
                    this.deliveryQtyFlag = false;
                }
                this.tagPackingQuantityType = type === 'deliveryQtyFlag' ? 'deliveryQuantity' : 'lastMinimumPackageQuantity';
            } else {
                this.tagPackingQuantityType = '';
            }
            this.onSearch();
        },
    },
    activated() {
        this.supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'));
        this.orderParams = this.$route.query.orderParams ? JSON.parse(this.$route.query.orderParams) : null;
        if (this.orderParams) {
            window.sessionStorage.setItem('createMaterialIntBarcodes', JSON.stringify(this.orderParams));
        } else {
            this.orderParams = JSON.parse(window.sessionStorage.getItem('createMaterialIntBarcodes'));
        }
        // 获取单据状态
        this.getDict('INT_deliveryOrderStatus', (data) => {
            this.deliverystatusList = data;
        });
        // GAT泰国机电标签打印快码
        this.getDict('INT_CUX_ITEM_TAG_TEMPLATE');
        this.getMaxPrintNum();
        this.onSearch();
    }
};
</script>
<style lang="less" scoped>
    .each-btn {
        margin: 8px 8px 8px 0;
    }
    .set-flex {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }
    .mg-ll-5 {
        margin-left: 5px;
    }
    .fs12 {
        font-size: 12px;
    }
    .mtb10 {
        margin: 10px 0;
    }
</style>
